import { DEFAULT_DATE_API_FORMAT } from "@slhuicore/utils/date.js";

const WEEK_DAYS_LENGHT = 7;
const CALENDAR_DAYS_LENGHT = 42;
const DEFAULT_DATE_FORMAT = DEFAULT_DATE_API_FORMAT;

export { WEEK_DAYS_LENGHT, CALENDAR_DAYS_LENGHT, DEFAULT_DATE_FORMAT };
